import { Environment } from '@onwardtravelsolutions/package-react/Enums';

type EnvironmentIndicatorProps = {
    env: Environment;
};

export default function EnvironmentIndicator({
    env,
}: EnvironmentIndicatorProps) {
    return (
        env !== Environment.Production && (
            <div
                id={`${env}-environment-indicator`}
                className='pointer-events-none -right-14 bottom-4 z-50 fixed bg-success shadow-md p-2.5 w-48 text-white text-xs text-center capitalize -rotate-45 transform'
            >
                {env}
            </div>
        )
    );
}
